import { Box, Tab, Tabs } from "@mui/material";
import { useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { CarWashProvider } from "../../../context/CarWashContext";
import { useTranslation } from "react-i18next";

interface ICarWashTabRoute {
  [key: number]: string;
}

const CarWashTabRoutes: ICarWashTabRoute = {
  0: "info",
  1: "contact-details",
  2: "statistics",
  3: "washing-history",
  4: "prices",
  5: "pending-reviews",
  6: "support-cases",
  7: "logs",
};

// Reverse mapping: route to tab index
const RouteToTabIndex: { [key: string]: number } = {
  info: 0,
  "contact-details": 1,
  statistics: 2,
  "washing-history": 3,
  prices: 4,
  "pending-reviews": 5,
  "support-cases": 6,
  logs: 7,
};

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CarWash = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  // Sync tab value with current route on mount and location changes
  useEffect(() => {
    const pathSegments = location.pathname.split("/");
    const currentRoute = pathSegments[pathSegments.length - 1];
    const tabIndex = RouteToTabIndex[currentRoute];
    if (tabIndex !== undefined) {
      setValue(tabIndex);
    }
  }, [location.pathname]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    navigate(CarWashTabRoutes[newValue]);
  };

  return (
    <CarWashProvider>
      <Box className="flex flex-col">
        <Tabs
          value={value}
          onChange={handleTabChange}
          aria-label={t("carWashes.innerNavAria")}
          scrollButtons="auto"
          variant="scrollable"
        >
          <Tab label={t("carWashes.tabInfo")} {...a11yProps(0)} />
          <Tab label={t("carWashes.tabContactDetails")} {...a11yProps(1)} />
          <Tab label={t("carWashes.tabStatistics")} {...a11yProps(2)} />
          <Tab label={t("carWashes.tabWashingHistory")} {...a11yProps(3)} />
          <Tab label={t("carWashes.tabPrices")} {...a11yProps(4)} />
          <Tab label={t("carWashes.tabPendingReviews")} {...a11yProps(5)} />
          <Tab label={t("carWashes.tabSupportCases")} {...a11yProps(6)} />
          <Tab label={t("carWashes.tabLogs")} {...a11yProps(7)} />
        </Tabs>

        <Outlet />
      </Box>
    </CarWashProvider>
  );
};

export default CarWash;
